import React from 'react'
import { NavLink, NavLinkProps } from 'react-router'
import Marker from '@components/Marker'
import { styled } from '@mui/material'
import { useExistsNotifications } from '@store/app'

const NotificationNavLink = styled(({ children, ...props }: NavLinkProps) => {
  const existsNotifications = useExistsNotifications()
  return (
    <NavLink {...props}>
      <>
        {existsNotifications && (
          <Marker
            className="NotificationNavLinkMarker"
            color="red"
            size={12}
          />
        )}
        {children}
      </>
    </NavLink>
  )
})(() => ({
  position: 'relative',
  '.NotificationNavLinkMarker': {
    border: '3px solid rgba(255,255,255,0.8)',
    boxShadow: '0 0 10px rgba(255,255,255,0.7)',
    position: 'absolute',
    height: 10,
    width: 10,
    left: 20,
  },
  '&.active .NotificationNavLinkMarker': {
    boxShadow: 'none',
    borderWidth: 0,
    height: 13,
    width: 13,
    left: 23,
  }
}))

export default NotificationNavLink